module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/CoverSection/accidental-damage-7de0895e8bd9b15e44038dec8c812709.png";